import { createSuitMixin as t } from "../mixins/suit.js";
import { createWidgetMixin as i } from "../mixins/widget.js";
import { connectRange as e } from "instantsearch.js/es/connectors/index.js";
import { createPanelConsumerMixin as n } from "../mixins/panel.js";
export default {
  name: "AisRangeInput",
  mixins: [t({
    name: "RangeInput"
  }), i({
    connector: e
  }, {
    $$widgetType: "ais.rangeInput"
  }), n()],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    min: {
      type: Number,
      required: !1,
      default: void 0
    },
    max: {
      type: Number,
      required: !1,
      default: void 0
    },
    precision: {
      type: Number,
      required: !1,
      default: 0
    }
  },
  data: function data() {
    return {
      minInput: void 0,
      maxInput: void 0
    };
  },
  updated: function updated() {
    this.minInput = void 0, this.maxInput = void 0;
  },
  computed: {
    widgetParams: function widgetParams() {
      return {
        attribute: this.attribute,
        min: this.min,
        max: this.max,
        precision: this.precision
      };
    },
    step: function step() {
      return 1 / Math.pow(10, this.precision);
    },
    values: function values() {
      var t = this.state.start,
          i = t[0],
          e = t[1],
          n = this.state.range,
          r = n.min,
          s = n.max;
      return {
        min: i !== -1 / 0 && i !== r ? i : void 0,
        max: e !== 1 / 0 && e !== s ? e : void 0
      };
    }
  },
  methods: {
    pick: function pick(t, i) {
      return null != t ? t : i;
    },
    refine: function refine(t) {
      var i = t.min,
          e = t.max;
      this.state.refine([i, e]);
    }
  }
};